import { useState, useCallback } from 'react'

/**
 * Custom hook for managing Item Renewal Simulator state
 */
export interface RenewalSimulatorState {
  isOpen: boolean
  renewalFlg: boolean | null
  centerId: string | null
  itemCode: string | null
  isUpdate: boolean
}

export interface RenewalSimulatorActions {
  openSimulator: (renewalFlg: boolean, centerId: string, itemCode: string) => void
  closeSimulator: () => void
  setUpdate: (value: boolean) => void
}

export function useRenewalSimulator() {
  const [state, setState] = useState<RenewalSimulatorState>({
    isOpen: false,
    renewalFlg: null,
    centerId: null,
    itemCode: null,
    isUpdate: false,
  })

  const openSimulator = useCallback((renewalFlg: boolean, centerId: string, itemCode: string) => {
    setState({
      isOpen: true,
      renewalFlg,
      centerId,
      itemCode,
      isUpdate: false,
    })
  }, [])

  const closeSimulator = useCallback(() => {
    setState({
      isOpen: false,
      renewalFlg: null,
      centerId: null,
      itemCode: null,
      isUpdate: false,
    })
  }, [])

  const setUpdate = useCallback((value: boolean) => {
    setState((prev) => ({
      ...prev,
      isUpdate: value,
    }))
  }, [])

  return {
    state,
    actions: {
      openSimulator,
      closeSimulator,
      setUpdate,
    },
  }
}

